<script setup lang="ts">
import Select from 'primevue/select'
import { ref, type ComponentPublicInstance } from 'vue'
import LoadingSpinner from '../../icons/LoadingSpinner.vue'
import { useSelect, type SelectProps } from './select'
import SelectFilter from './SelectFilter.vue'

const props = withDefaults(defineProps<SelectProps>(), { showFilter: true })
const model = defineModel<string>({ default: '' })
const rootElement = ref<ComponentPublicInstance | null>(null)
const { attrs, loading, loadOptions } = useSelect(model, props, rootElement)
</script>

<template>
  <Select ref="rootElement" v-bind="attrs" scroll-height="24rem" :pt="{ label: { 'data-value': model } }">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps" />
    </template>
    <template #header>
      <SelectFilter v-if="props.showFilter" @update:modelValue="loadOptions" />
    </template>
    <template v-if="loading" #empty>
      <div class="flex items-center justify-center overflow-hidden">
        <LoadingSpinner class="h-16 w-16" />
      </div>
    </template>
  </Select>
</template>
